export const SETTINGS_STORES_PATH = "/settings?tab=stores";

export const TUTORIAL_ROUTES = {
  "/dashboard": "dashboard",
  "/settings": "settings",
  "/items": "items",
  "/walmart/listings": "listings",
  "/walmart/inventory": "inventory",
  "/walmart/buybox": "buybox",
  "/walmart/orders": "orders",
  "/walmart/pricing": "pricing",
  "/walmart/profit-loss": "profit_loss",
  "/walmart/recon": "recon",
  "/walmart/advertising": "advertising",
  "/walmart/campaigns": "campaigns",
  "/walmart/insights": "insights",
  "/walmart/marketing": "marketing",
  "/walmart/compare": "compare",
  "/walmart/feeds": "feeds",
  "/walmart/wfs-services": "wfs_services",
  "/wfs-estimator": "wfs_estimator",
  "/walmart/data-sync": "data_sync",
};

export function tutorialPageIdFromPath(pathname) {
  const path = (pathname || "/").replace(/\/$/, "") || "/";
  return TUTORIAL_ROUTES[path] || null;
}
